import * as RD from '@radix-ui/react-dialog';
import type { ReactNode } from 'react';
import { IconClose } from '../Icons';

/**
 * A modal. `variant="sheet"` slides up from the bottom (phones) and
 * `variant="panel"` slides in from the right (desktop side panels).
 */
export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  variant = 'modal',
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  variant?: 'modal' | 'sheet' | 'panel';
}) {
  return (
    <RD.Root open={open} onOpenChange={onOpenChange}>
      <RD.Portal>
        <RD.Overlay className="ui-dialog-overlay" />
        <RD.Content className={`ui-dialog ui-dialog-${variant}`}>
          <header className="ui-dialog-head">
            <RD.Title className="ui-dialog-title">{title}</RD.Title>
            <RD.Close className="btn btn-ghost btn-sm" aria-label="Close">
              <IconClose size={16} />
            </RD.Close>
          </header>
          {/* Radix wants a description for screen readers; a hidden one stands in. */}
          <RD.Description className={description ? 'ui-dialog-desc' : 'sr-only'}>
            {description ?? (typeof title === 'string' ? title : 'Dialog')}
          </RD.Description>
          <div className="ui-dialog-body">{children}</div>
          {footer && <footer className="ui-dialog-foot">{footer}</footer>}
        </RD.Content>
      </RD.Portal>
    </RD.Root>
  );
}
